var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "px-3 py-4 add-product-modal",
      attrs: { action: "self" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submitAddProduct($event)
        }
      }
    },
    [
      _c("p", [
        _vm._v(
          "Please select a product to add to this quote. Adding a product will change this quote into a bundle. You can still bind a single product when this quote is a bundle if desired."
        )
      ]),
      _vm._v(" "),
      _vm.formErrors.general
        ? _c("div", { staticClass: "px-3 py-2" }, [
            _c(
              "div",
              { staticClass: "alert alert-danger", attrs: { role: "alert" } },
              [_vm._v("\n      " + _vm._s(_vm.formErrors.general) + "\n    ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "inner-div px-3 pt-8 pb-4" }, [
        _c("div", { staticClass: "selected-product-row pb-2" }, [
          _c("label", [_vm._v("Selected Product")]),
          _c("br"),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "product-name", class: "" + _vm.productName },
            [_vm._v(_vm._s(_vm.productName))]
          )
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "pt-2",
            class:
              _vm.productName == "Home" ||
              _vm.productName == "Condo" ||
              _vm.productName == "Renters"
                ? "btn100"
                : "btnsplit"
          },
          [
            _c("input-product-type", {
              attrs: { insuranceType: _vm.formFields.insuranceType }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary d-block mx-auto",
          attrs: { type: "submit", id: "add-product-submit-button" }
        },
        [_vm._v("Add Product")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddb6bd96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddb6bd96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/shared/AddProductModal.vue
// module id = null
// module chunks = 